// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
  cybersourceUrl: 'https://testsecureacceptance.cybersource.com/pay',
  origin: 'https://mpapitest-6.radiantdelivers.com/api/v1/payments/',
  // origin: 'http://127.0.0.1:8080/api/v1/payments/',
  mock: false,
  gtagId: '',
  maintenanceUrl: 'https://rgl-static-cdn.s3.amazonaws.com/maintenance_dev.json',
  lambdaApi: 'https://rgl-node-payment-portal-dev.radiantdelivers.com/payments/',
  localLambdaApi: 'http://localhost:3000/payments/',
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
